import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseUsersCapacityHoursPayload } from '../payloads/usersCapacityHoursPayload';
import { InsightChartFactory } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';

export const buildUsersCapacityHoursInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseUsersCapacityHoursPayload(payload);
  const { total_capacity_hours } = parsedPayload.data.attributes.aggregate;

  return (props) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.KPI)
      .setProps({
        chartData: {
          value: total_capacity_hours.current ?? 0,
          trend: total_capacity_hours.percentage_change ?? 0,
          trendIsPercent: true,
          description: props.name,
        },
        onDrillDown: props.onDrillDown,
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
